<template>
    <div class="">

        <div class="">

            <slot>
                <h2 class="text-base p-4 tracking-wide">
                    <i class="fa fa-sliders"></i> Filter
                </h2>
            </slot>

            <div class="px-0">

                <database-filter-search :root="root" :database="database" :codes="codes" class="px-2"></database-filter-search>

                <div class="overflow-y-auto pt-4 pb-4 px-2" style="max-height: 50vh;">

                    <fetch-tree :database="database" :codes="codes" :root="root">
                        <filter-item-root :codes="codes" :folder-select="folderSelect"></filter-item-root>
                    </fetch-tree>

                </div>

            </div>
        </div>

    </div>
</template>

<script>

    import FilterItem from "./FilterItem";
    import FilterSearch from "./FilterSearch";

    import FilterItemRoot from "./FilterItemRoot";
    import FetchTree from "./FetchTree";

    export default {

        props: {
            'codes': Object,
            'database': {
                type: String,
                required: true,
            },
            'root': {
                type: String,
                required: false,
                default: null,
            },
            folderSelect: {
                default: true,
            },
            store: {
                type: Boolean,
                default: true,
            }
        },

        components: {
            FetchTree,
            FilterItemRoot,
            DatabaseFilterItem: FilterItem,
            DatabaseFilterSearch: FilterSearch,
        },
    }
</script>
